// Slack API helper - thin wrapper around the slack-post Netlify function.
// Pattern mirrors src/utils/notificationsApi.js (sendEmail / sendSMS).
//
// All calls are best-effort: callers should treat Slack as a fan-out
// channel, not authoritative. Firestore writes remain the source of truth.

const API_BASE = '/.netlify/functions';

async function callSlackPost(type, data) {
  try {
    const response = await fetch(`${API_BASE}/slack-post`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type, data })
    });

    let result;
    try {
      result = await response.json();
    } catch (parseError) {
      return { success: false, error: `Slack server returned invalid response (status ${response.status})` };
    }

    if (!response.ok) {
      return { success: false, error: result.error || result.slackError || `Slack post failed with status ${response.status}` };
    }

    return { success: true, ...result };
  } catch (error) {
    console.error('Slack post error:', error);
    return { success: false, error: error.message || 'Network error posting to Slack' };
  }
}

export function postToSlack({ type, data }) {
  return callSlackPost(type, data);
}

export function postAnnouncement({ subject, body, fromName, channelId }) {
  return callSlackPost('announcement', { subject, body, fromName, channelId });
}

export function postDirect({ slackUserId, subject, body }) {
  return callSlackPost('direct', { channelId: slackUserId, subject, body });
}

export function postJobAssigned({ clientName, jobAddress, time, teamNames, channelId }) {
  return callSlackPost('job_assigned', { clientName, jobAddress, time, teamNames, channelId });
}

export function postScheduleUpdate({ body, channelId }) {
  return callSlackPost('schedule_update', { body, channelId });
}

export function postTeamRoute({ teamNames, date, jobs, channelId }) {
  return callSlackPost('team_route', { teamNames, date, jobs, channelId });
}

export function postWithAttachment({ type, data, fileUrl, filename }) {
  return callSlackPost(type, { ...data, fileUrl, filename });
}
